import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Api_Token } from "../../../env";
import { useAlertContext } from "../../../service/AlertServices";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
import Indexdasbord from "../../../composant/navbar/indexDashbord";

export default function PageUser() {
  return <Indexdasbord Children={<UserManagement />} />;
}

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [magasins, setMagasins] = useState([]);
  const [events, setEvents] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    fullName: "",
    Email: "",
    password: "",
    Role: "",
    idMagasin: "",
    idEvent: "",
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [errors, setErrors] = useState({});
  const { showAlert } = useAlertContext();

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await Api_Token.get(
        `users/all?page=${page + 1}&limit=${rowsPerPage}`
      );
      setUsers(res.data.users || []);
      setTotal(res.data.total || 0);
    } catch {
      showAlert("Erreur chargement users", "error");
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, showAlert]);

  const fetchMagasins = useCallback(async () => {
    try {
      const res = await Api_Token.get("magasin/getMagasin");
      setMagasins(res.data || []);
    } catch {}
  }, []);

  const fetchEvents = useCallback(async () => {
    try {
      const res = await Api_Token.get("event/getEvents");
      setEvents(res.data.data || []);
    } catch {}
  }, []);

  useEffect(() => {
    fetchUsers();
    fetchMagasins();
    fetchEvents();
  }, [fetchUsers, fetchMagasins, fetchEvents]);
  const handleEdit = (user) => {
    setFormData({
      id: user.id,
      fullName: user.fullName || "",
      Email: user.Email || "",
      password: "",
      Role: user.Role || null,
      idMagasin: user.idMagasin || "",
      idEvent: user.idEvent || "",
    });
    setErrors({});
    setOpenForm(true);
  };

  const handleDelete = async (id) => {
    try {
      await Api_Token.delete(`users/delete/${id}`);
      showAlert("Utilisateur supprimé", "success");
      fetchUsers();
    } catch {
      showAlert("Erreur suppression", "error");
    }
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.fullName || formData.fullName.trim() === "") {
      newErrors.fullName = "Le nom est requis";
    }
    if (!formData.Email || formData.Email.trim() === "") {
      newErrors.Email = "L'email est requis";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.Email)) {
      newErrors.Email = "Email invalide";
    }
    if (!formData.id && (!formData.password || formData.password.length < 8)) {
      newErrors.password = "Mot de passe requis (min 8 caractères)";
    }
    if (!formData.Role) {
      newErrors.Role = "Le rôle est requis";
    }
    if (!formData.idMagasin && !formData.idEvent) {
      newErrors.idMagasin = "Sélectionnez un magasin ou un event";
      newErrors.idEvent = "Sélectionnez un magasin ou un event";
    }
    return newErrors;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    console.log("formData", formData);
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
    try {
      if (formData.id) {
        console.log("formData 2", formData);
        await Api_Token.put(`users/update/${formData.id}`, formData);
        showAlert("Utilisateur modifié", "success");
      } else {
        await Api_Token.post("users/create", formData);
        showAlert("Utilisateur ajouté", "success");
      }
      setOpenForm(false);
      fetchUsers();
    } catch {
      showAlert("Erreur formulaire", "error");
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" mb={3}>
        Gestion des utilisateurs
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => {
          setFormData({
            id: null,
            username: "",
            email: "",
            role: null,
            magasinId: "",
            eventId: "",
          });
          setOpenForm(true);
        }}
        sx={{ mb: 2 }}
      >
        Ajouter utilisateur
      </Button>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Rôle</TableCell>
              <TableCell>Magasin</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.fullName}</TableCell>
                <TableCell>{user.Email}</TableCell>
                <TableCell>{user.Role}</TableCell>
                <TableCell>{user.Magasin ? user.Magasin.Nom : ""}</TableCell>
                <TableCell>{user.Event ? user.Event.Nom : ""}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleEdit(user)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(user.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 20]}
        />
      </Paper>
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <form onSubmit={handleFormSubmit} noValidate>
          <DialogTitle>
            {formData.id ? "Modifier" : "Ajouter"} utilisateur
          </DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Nom"
              fullWidth
              required
              value={formData.fullName || ""}
              onChange={(e) =>
                setFormData({ ...formData, fullName: e.target.value })
              }
              error={!!errors.fullName}
              helperText={errors.fullName}
            />
            <TextField
              margin="dense"
              label="Email"
              fullWidth
              required
              value={formData.Email || ""}
              onChange={(e) =>
                setFormData({ ...formData, Email: e.target.value })
              }
              error={!!errors.Email}
              helperText={errors.Email}
            />
            <TextField
              margin="dense"
              label="Mot de passe"
              type="password"
              fullWidth
              required={!formData.id}
              value={formData.password || ""}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              autoComplete="new-password"
              error={!!errors.password}
              helperText={errors.password}
            />
            <FormControl
              fullWidth
              margin="dense"
              required
              error={!!errors.Role}
            >
              <InputLabel id="role-label">Rôle</InputLabel>
              <Select
                labelId="role-label"
                value={formData?.Role}
                label="Rôle"
                onChange={(e) =>
                  setFormData({ ...formData, Role: e.target.value })
                }
              >
                <MenuItem value="gerant">Gérant</MenuItem>
                <MenuItem value="user">User</MenuItem>
              </Select>
              {errors.Role && (
                <Typography color="error" variant="caption">
                  {errors.Role}
                </Typography>
              )}
            </FormControl>
            <FormControl
              fullWidth
              margin="dense"
              required
              error={!!errors.idMagasin}
            >
              <InputLabel id="magasin-label">Magasin</InputLabel>
              <Select
                labelId="magasin-label"
                value={formData.idMagasin || ""}
                label="Magasin"
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    idMagasin: e.target.value,
                    idEvent: "",
                  });
                }}
                disabled={!!formData.idEvent}
              >
                <MenuItem value="">Aucun</MenuItem>
                {magasins.map((magasin) => (
                  <MenuItem key={magasin.id} value={magasin.id}>
                    {magasin.Nom}
                  </MenuItem>
                ))}
              </Select>
              {errors.idMagasin && (
                <Typography color="error" variant="caption">
                  {errors.idMagasin}
                </Typography>
              )}
            </FormControl>
            <FormControl
              fullWidth
              margin="dense"
              required
              error={!!errors.idEvent}
            >
              <InputLabel id="event-label">Event</InputLabel>
              <Select
                labelId="event-label"
                value={formData.idEvent || ""}
                label="Event"
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    idEvent: e.target.value,
                    idMagasin: "",
                  });
                }}
                disabled={!!formData.idMagasin}
              >
                <MenuItem value="">Aucun</MenuItem>
                {events.map((event) => (
                  <MenuItem key={event.id} value={event.id}>
                    {event.Nom}
                  </MenuItem>
                ))}
              </Select>
              {errors.idEvent && (
                <Typography color="error" variant="caption">
                  {errors.idEvent}
                </Typography>
              )}
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenForm(false)}>Annuler</Button>
            <Button type="submit" color="primary">
              {formData.id ? "Modifier" : "Ajouter"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <BackLoadingSimple open={loading} />
    </Box>
  );
}
